import { FC, useState } from 'react';
import { WrapInLayout } from '../layouts';
import { orderApi } from '../api/order.api';
import OrdersCategoryList from '../components/orders/OrdersCategoryList';
import OrdersDrilldownModal from '../components/orders/OrdersDrilldownModal';
import { DRILLDOWN_BY_DMA, SUMMARY_BY_DMA } from '../components/orders/categoryColumns';
import { IDateRange, presetRange } from '../components/orders/orderDatePresets';

const OrdersByDmaPage: FC = () => {
  const [range, setRange] = useState<IDateRange>(() => presetRange('month'));

  const { data, isFetching, isError, error } = orderApi.useGetOrdersByDmaQuery({
    createdFrom: range.createdFrom,
    createdTill: range.createdTill,
  });

  return (
    <WrapInLayout title="Orders By DMA" layout="dashboard">
      <h1 className="text-xl font-semibold mb-3">Orders By DMA</h1>
      <OrdersCategoryList
        categoryTitle="metro_name"
        columns={SUMMARY_BY_DMA}
        unit="market(s)"
        resizeStorageKey="orders-by-dma"
        rows={data}
        isFetching={isFetching}
        isError={isError}
        error={error}
        range={range}
        onRangeChange={setRange}
        renderDrilldown={(row, close) => (
          <OrdersDrilldownModal
            title={`Orders in ${row.category}`}
            columns={DRILLDOWN_BY_DMA}
            createdFrom={range.createdFrom}
            createdTill={range.createdTill}
            dma={row.category}
            onClose={close}
          />
        )}
      />
    </WrapInLayout>
  );
};

export default OrdersByDmaPage;
